"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncUploadWatcher = asyncUploadWatcher;

var _effects = require("redux-saga/effects");

var actions = _interopRequireWildcard(require("./actions"));

var types = _interopRequireWildcard(require("./types"));

var modalActions = _interopRequireWildcard(require("../../../modal/actions"));

var _apiRequest = require("../../api/apiRequest");

var _Utils = _interopRequireDefault(require("../../../../utils/Utils"));

var _selectors = require("../../../locale/selectors");

var modalTypes = _interopRequireWildcard(require("../../../modal/types"));

var _modalTypes = require("../../../../constants/modalTypes");

var _selectors2 = require("./selectors");

var _urls = require("../../../../constants/urls");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(checkUploadStatus),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(uploadWorker),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(asyncUploadWatcher);

var uploadController = null; // function* abortDownload() {
//     yield put(actions.abort());
//     if(downloadController){
//         downloadController.abort();
//     }
// }

function checkUploadStatus(action) {
  var _action$payload, importKey, fileUUID, isFetching, locale, status, fileInfo, isAborted;

  return regeneratorRuntime.wrap(function checkUploadStatus$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _action$payload = action.payload, importKey = _action$payload.importKey, fileUUID = _action$payload.fileUUID;

        case 2:
          if (!true) {
            _context.next = 42;
            break;
          }

          _context.next = 5;
          return (0, _effects.delay)(2000);

        case 5:
          _context.next = 7;
          return (0, _effects.select)(_selectors2.getIsFetching);

        case 7:
          isFetching = _context.sent;

          if (isFetching) {
            _context.next = 10;
            break;
          }

          return _context.abrupt("break", 42);

        case 10:
          _context.next = 12;
          return (0, _effects.select)(_selectors.getLocale);

        case 12:
          locale = _context.sent;
          _context.next = 15;
          return (0, _effects.call)(_apiRequest.apiRequest, _urls.UPLOAD_URLS.UPLOAD_STATUS, "GET", {
            query: {
              importKey: importKey,
              uuid: fileUUID
            },
            locale: locale
          });

        case 15:
          status = _context.sent;

          if (!status) {
            _context.next = 40;
            break;
          }

          _context.next = 19;
          return (0, _effects.put)(actions.setStatus(status));

        case 19:
          if (!(status.info !== null)) {
            _context.next = 22;
            break;
          }

          _context.next = 22;
          return (0, _effects.put)(modalActions.setText(status.info));

        case 22:
          fileInfo = status.asyncFileInfo;

          if (!fileInfo) {
            _context.next = 38;
            break;
          }

          if (!(fileInfo.uuid === null || fileInfo.error && !fileInfo.errorReason)) {
            _context.next = 28;
            break;
          }

          throw new Error("error during file " + fileUUID + " processing");

        case 28:
          if (!(fileInfo.error && fileInfo.errorReason)) {
            _context.next = 33;
            break;
          }

          _context.next = 31;
          return (0, _effects.put)(actions.failureWithPayload(fileInfo));

        case 31:
          _context.next = 36;
          break;

        case 33:
          if (!fileInfo.ready) {
            _context.next = 36;
            break;
          }

          _context.next = 36;
          return (0, _effects.put)(actions.setReady());

        case 36:
          _context.next = 40;
          break;

        case 38:
          _context.next = 40;
          return (0, _effects.put)(actions.failure());

        case 40:
          _context.next = 2;
          break;

        case 42:
          _context.next = 55;
          break;

        case 44:
          _context.prev = 44;
          _context.t0 = _context["catch"](0);
          _context.next = 48;
          return (0, _effects.select)(_selectors2.getIsAborted);

        case 48:
          isAborted = _context.sent;

          if (isAborted) {
            _context.next = 55;
            break;
          }

          console.error(_context.t0);
          _context.next = 53;
          return (0, _effects.put)(modalActions.show("error/errorMessage", _context.t0.message, _modalTypes.MODAL_TYPES.ERROR));

        case 53:
          _context.next = 55;
          return (0, _effects.put)(actions.failure());

        case 55:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 44]]);
}

function uploadWorker(action) {
  var _action$payload2, url, filterParams, _action$payload2$clos, closeModalOnFailure, _action$payload2$meth, method, locale, queryString, downloadUrl, asyncResultResponse, fileUUID, _ref, success, failure, failureWithPayload, isAborted;

  return regeneratorRuntime.wrap(function uploadWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _action$payload2 = action.payload, url = _action$payload2.url, filterParams = _action$payload2.filterParams, _action$payload2$clos = _action$payload2.closeModalOnFailure, closeModalOnFailure = _action$payload2$clos === void 0 ? false : _action$payload2$clos, _action$payload2$meth = _action$payload2.method, method = _action$payload2$meth === void 0 ? "POST" : _action$payload2$meth;
          uploadController = new AbortController(); // Start download

          _context2.next = 5;
          return (0, _effects.put)(actions.start());

        case 5:
          _context2.next = 7;
          return (0, _effects.put)(modalActions.show('view/fileUploadStarted/title', 'view/fileUploadStarted/text', null, 'buttons/cancel'));

        case 7:
          _context2.next = 9;
          return (0, _effects.select)(_selectors.getLocale);

        case 9:
          locale = _context2.sent;
          queryString = _Utils["default"].buildQueryString({
            importKey: filterParams.importKey
          });
          downloadUrl = "".concat(url).concat(queryString); // Request download

          _context2.next = 14;
          return (0, _effects.call)(_apiRequest.apiRequest, downloadUrl, method, {
            body: method === 'POST' ? filterParams : undefined,
            locale: locale,
            timeout: 0
          }, uploadController.signal);

        case 14:
          asyncResultResponse = _context2.sent;
          fileUUID = asyncResultResponse.uuid; // Begin check status

          if (!filterParams.importKey) {
            _context2.next = 19;
            break;
          }

          _context2.next = 19;
          return (0, _effects.put)(actions.sagaStatus(filterParams.importKey, fileUUID));

        case 19:
          _context2.next = 21;
          return (0, _effects.race)({
            success: (0, _effects.take)(types.SET_READY),
            failure: (0, _effects.take)(types.FAILURE),
            // if correct response received with error status
            failureWithPayload: (0, _effects.take)(types.FAILURE_WITH_PAYLOAD)
          });

        case 21:
          _ref = _context2.sent;
          success = _ref.success;
          failure = _ref.failure;
          failureWithPayload = _ref.failureWithPayload;

          if (!(failure || failureWithPayload && !closeModalOnFailure)) {
            _context2.next = 27;
            break;
          }

          return _context2.abrupt("return");

        case 27:
          _context2.next = 29;
          return (0, _effects.put)(modalActions.close());

        case 29:
          if (!(!failureWithPayload && !failure)) {
            _context2.next = 32;
            break;
          }

          _context2.next = 32;
          return (0, _effects.put)(actions.success());

        case 32:
          _context2.next = 45;
          break;

        case 34:
          _context2.prev = 34;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 38;
          return (0, _effects.select)(_selectors2.getIsAborted);

        case 38:
          isAborted = _context2.sent;

          if (isAborted) {
            _context2.next = 45;
            break;
          }

          console.error(_context2.t0);
          _context2.next = 43;
          return (0, _effects.put)(modalActions.show("error/errorMessage", _context2.t0.message, _modalTypes.MODAL_TYPES.ERROR));

        case 43:
          _context2.next = 45;
          return (0, _effects.put)(actions.failure());

        case 45:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 34]]);
}

function asyncUploadWatcher() {
  return regeneratorRuntime.wrap(function asyncUploadWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, uploadWorker);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeEvery)(types.SAGA_STATUS, checkUploadStatus);

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}